import { useEffect, useState } from 'react';
import { db } from '../lib/firebase';
import { collection, query, where, onSnapshot, orderBy, limit } from 'firebase/firestore';

export default function HomeScreen({ user, userData, onNavigate }) {
  const [onlineUsers, setOnlineUsers]   = useState([]);
  const [chatPreview, setChatPreview]   = useState('');
  const [onlineCount, setOnlineCount]   = useState(0);

  useEffect(() => {
    const q = query(collection(db, 'users'), where('online', '==', true));
    return onSnapshot(q, snap => {
      const others = [];
      snap.forEach(d => { if (d.id !== user.uid) others.push(d.data()); });
      setOnlineUsers(others);
      setOnlineCount(others.length);
    });
  }, [user.uid]);

  useEffect(() => {
    const q = query(collection(db,'groups','main','messages'), orderBy('timestamp','desc'), limit(1));
    return onSnapshot(q, snap => {
      if (!snap.empty) {
        const last = snap.docs[0].data();
        const who  = last.senderId === user.uid ? 'You' : last.senderName;
        const txt  = last.type === 'voice' ? '🎤 Voice message' : last.text;
        setChatPreview(`${who}: ${txt}`);
      }
    });
  }, [user.uid]);

  return (
    <div className="screen">
      <div className="screen-header">
        <div>
          <div className="screen-title">hangout 🏠</div>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 2 }}>
            {onlineCount} {onlineCount === 1 ? 'fren' : 'frens'} online
          </div>
        </div>
        <div className="avatar" style={{ background: userData?.avatarBg, color: userData?.avatarText }}>
          {userData?.initials}
        </div>
      </div>

      <div className="scroll-area">
        {/* Online strip */}
        {onlineUsers.length > 0 && (
          <>
            <div className="section-label">online now</div>
            <div className="online-strip">
              {onlineUsers.map(u => (
                <div key={u.uid} className="online-friend" onClick={() => onNavigate('chat')}>
                  <div className="avatar-wrap">
                    <div className="avatar sm online-ring" style={{ background: u.avatarBg, color: u.avatarText }}>
                      {u.initials}
                    </div>
                    <div className="online-dot" />
                  </div>
                  <span className="friend-name">{u.displayName.split(' ')[0]}</span>
                </div>
              ))}
            </div>
          </>
        )}

        <div className="section-label">quick access</div>
        <div className="quick-grid">
          <div className="quick-card" onClick={() => onNavigate('chat')}>
            <div className="quick-icon amber"><i className="ti ti-message-circle-2" /></div>
            <div className="quick-label">group chat</div>
            <div className="quick-sub">{chatPreview || 'tap to open'}</div>
          </div>
          <div className="quick-card" onClick={() => onNavigate('voice')}>
            <div className="quick-icon green"><i className="ti ti-microphone" /></div>
            <div className="quick-label">voice room</div>
            <div className="quick-sub">hang & talk</div>
          </div>
          <div className="quick-card" onClick={() => onNavigate('vibes')}>
            <div className="quick-icon blue"><i className="ti ti-sparkles" /></div>
            <div className="quick-label">vibes</div>
            <div className="quick-sub">share moments</div>
          </div>
          <div className="quick-card" onClick={() => onNavigate('expense')}>
            <div className="quick-icon red"><i className="ti ti-receipt-2" /></div>
            <div className="quick-label">splits</div>
            <div className="quick-sub">track expenses</div>
          </div>
        </div>
      </div>
    </div>
  );
}
